import { FunctionComponent } from 'react';
import { SlideshowCover } from 'types/Slideshow';
import { useTranslation } from 'react-i18next';
import Icon from 'components/Shared/Icon';
import redArrow from 'components/Slideshow/red-right-arrow.svg';
import { colors, fonts, screen } from 'components/styles/variables';
import Markdown from 'markdown-to-jsx';

interface CoverSlideProps {
  slide: SlideshowCover;
  nextSlide?: () => void;
}

const CoverSlide: FunctionComponent<CoverSlideProps> = ({ slide, nextSlide }: CoverSlideProps) => {
  const { photoCredit, caption, photoUrl } = slide;
  const { t } = useTranslation();

  return (
    <>
      <figure className="slide-photo-container">
        <img src={photoUrl} alt="image" />
        {photoCredit && <figcaption className="slide-photo-cred">{photoCredit}</figcaption>}
      </figure>
      <div className="slide-text">
        <div className="slide-caption">
          <Markdown>{caption}</Markdown>
        </div>
        <div className="next-page-button-container">
          {
            <button onClick={nextSlide} className="next-page-button">
              <div>{t('contentSlideshow.nextImage')}</div>
              <Icon image={redArrow} />
            </button>
          }
        </div>
      </div>
      <style jsx>{`
        .slide-photo-container {
          position: relative;
          height: 100%;
          margin: 0;
        }

        .slide-photo-container img {
          width: 100vw;
          max-width: 725px;
        }

        .slide-photo-cred {
          position: absolute;
          right: 0;
          bottom: 0;
          padding: 2px 26px 3px 26px;
          background-color: rgba(0, 0, 0, 0.75);
          color: white;
          letter-space: 0.15px;
          font-size: 12px;
          font-weight: 300;
        }

        .slide-text {
          padding: 24px 32px;
        }

        .slide-caption {
          color: ${colors.BLACK};
          font-weight: 300;
          font-size: 18px;
        }

        .next-page-button {
          display: flex;
          align-items: center;
          color: ${colors.ALR1};
          font-weight: 600;
          font-size: 16px;
          margin-top: 32px;
          border: none;
          padding: 0;
          cursor: pointer;
          font-family: ${fonts.default};
          background-color: transparent;
        }

        .next-page-button-container {
          display: none;
        }

        @media (min-width: ${screen.smMin}) {
          .next-page-button-container {
            display: flex;
            justify-content: flex-end;
          }
        }
      `}</style>
    </>
  );
};

export default CoverSlide;
